import { Image } from "@mantine/core";
import { HiOutlineHome, HiOutlinePhone } from "react-icons/hi2";
import ContactInformation from "../../constants/contact-information";
import MessengerIcon from "/messenger.svg";
import XIcon from "/x.svg";
import ZaloIcon from "/zalo.svg";

const ICON_SIZE = 48;

export default function MainContactContent() {
  return (
    <div className="main-contact-content">
      {/* Contact via */}
      <h1 className="font-bold text-xl md:text-sm">Liên lạc qua</h1>
      <div className="flex gap-1 my-4">
        <a
          href={ContactInformation.zalo}
          // target="_blank"
          className="rounded-xl focus:bg-neutral-300 p-2"
        >
          <Image src={ZaloIcon} w={ICON_SIZE} h={ICON_SIZE} />
        </a>
        <a
          href={ContactInformation.messenger}
          // target="_blank"
          className="rounded-xl focus:bg-neutral-300 p-2"
        >
          <Image src={MessengerIcon} w={ICON_SIZE} height={ICON_SIZE} />
        </a>
        <a
          href={ContactInformation.x}
          // target="_blank"
          className="rounded-full focus:bg-neutral-300 p-2"
        >
          <Image src={XIcon} w={ICON_SIZE} height={ICON_SIZE} />
        </a>
      </div>

      <h1 className="text-xl md:text-sm font-bold mb-2">Thông tin liên lạc</h1>
      {/* Phone number */}
      <div>
        <p className="flex flex-row items-center gap-4 py-2">
          <span>
            <HiOutlinePhone />
          </span>
          <a className="underline" href="tel:+84945929960">
            (+84) 945 929 960
          </a>
        </p>

        {/* Address */}
        <p className="flex flex-row items-center gap-4 py-2">
          <span>
            <HiOutlineHome />
          </span>
          <b className="text-sm md:text-xs">
            702 An Dương Vương, Phường 13, Quận 6, Thành phố Hồ Chí Minh
          </b>
        </p>
      </div>

      {/* Map view */}

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15679.149486809563!2d106.6245514!3d10.7508641!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752d00175cfadf%3A0x94c32d9d521c2c9f!2sPopper24h!5e0!3m2!1svi!2s!4v1712131758901!5m2!1svi!2s"
        // width="600"
        className="w-full"
        height="450"
        // style="border:0;"
        allowFullScreen={true}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
